module.exports = __webpack_public_path__ + "img/chart_active_24dp.a10e2be7.png";